<div>
  <div class="text-center w-100 mt-5 p-4">
    <mat-card class="card-general">
      <mat-card-title>Confirmar para elaborar setup digital</mat-card-title>
      <mat-card-content>
        <p class="row">Estás por enviar y registrar este caso, confirma que todos los datos y documentos están listos.</p>
        <!--<mat-radio-group aria-label="Seleciona una opción" [(ngModel)]="caseWizardService.confirmCase" class="d-flex gap-4 mt-4">
          <mat-radio-button *ngFor="let item of caseConfirmOptions" [value]="item.value">{{item.display}}</mat-radio-button>
        </mat-radio-group>-->
      </mat-card-content>
    </mat-card>
    <div class="text-center">
      <mat-checkbox style="width: fit-content;" class="col text-start"  (change)="onCheckboxChange($event.checked)"><span style="white-space:normal;" >Confirmo que la información anteriormente detallada es correcta y acepto que mi propuesta de setup se hará con base a la información previamente detallada.</span></mat-checkbox>
    </div>
  </div>

  <div class="text-center my-4">
    <button mat-button *ngIf="getUrlPDF!==''" class="btn btn-info text-white p-2 mx-auto" style="max-width: 300px;" (click)="openPDFDocument()">Ver prescripción <mat-icon>description</mat-icon></button>
  </div>
</div>
